import createRequestTypes from 'app/utils/createRequestTypes'

export const LOAD_WHITELABELS_LIST = createRequestTypes('LOAD_WHITELABELS_LIST')

export function loadWhitelabelsListRequest() {
  return {
    type: LOAD_WHITELABELS_LIST.REQUEST,
  }
}
